import { render, staticRenderFns } from "./InvoiceConfigEdit.vue?vue&type=template&id=5c15e2a4&scoped=true"
import script from "./InvoiceConfigEdit.vue?vue&type=script&lang=js"
export * from "./InvoiceConfigEdit.vue?vue&type=script&lang=js"
import style0 from "./InvoiceConfigEdit.vue?vue&type=style&index=0&id=5c15e2a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c15e2a4",
  null
  
)

export default component.exports